var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: `${_vm.summaryMode ? "sidebarVisible" : "sidebarCollapsed"}`,
      attrs: { id: "booking-process" },
    },
    [
      _c("datepicker", {
        ref: "datepicker",
        attrs: {
          productId: _vm.productId,
          moduleCollapsed: _vm.moduleCollapsed("datepicker"),
        },
        on: {
          "next-started": function ($event) {
            return _vm.showModule("roomResults")
          },
          failed: function ($event) {
            return _vm.showModule("datepicker")
          },
          "next-loaded": _vm.assignRoomResults,
          "flight-mode-changed": _vm.setShowFlightSteps,
          "enable-sidebar": function ($event) {
            _vm.summaryEnabled = true
          },
          "section-clicked": _vm.stepBackFrom,
        },
      }),
      _vm._v(" "),
      _vm.moduleVisible("roomResults")
        ? _c("room-results", {
            ref: "roomResults",
            attrs: {
              productId: _vm.productId,
              moduleCollapsed: _vm.moduleCollapsed("roomResults"),
              result: _vm.roomResults,
              "is-vp-mode": _vm.isVpMode,
            },
            on: {
              "next-started": _vm.showModule,
              "next-loaded": _vm.assignRoomSelection,
              "section-clicked": _vm.stepBackFrom,
              "step-back": _vm.stepBackFrom,
              failed: function ($event) {
                return _vm.showModule("datepicker")
              },
            },
          })
        : _c("booking-section", {
            attrs: {
              preview: true,
              title: _vm.$t("booking.sectionTitles.roomResults"),
            },
          }),
      _vm._v(" "),
      _vm.moduleVisible("flightResults")
        ? _c("flight-results", {
            ref: "flightResults",
            attrs: {
              productId: _vm.productId,
              moduleCollapsed: _vm.moduleCollapsed("flightResults"),
              result: _vm.flightResults,
              "is-vp-mode": _vm.isVpMode,
            },
            on: {
              "next-started": function ($event) {
                _vm.isVpMode || true
                  ? _vm.showModule("services")
                  : _vm.showModule("leadForm")
              },
              "next-loaded": _vm.assignProceedAfterFlight,
              "section-clicked": _vm.stepBackFrom,
              failed: function ($event) {
                return _vm.showModule("datepicker")
              },
            },
          })
        : _vm.showFlightSteps
        ? _c("booking-section", {
            attrs: {
              preview: true,
              title: _vm.$t("booking.sectionTitles.flightResults"),
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isVpMode || true
        ? [
            _vm.moduleVisible("services")
              ? _c("services", {
                  ref: "services",
                  attrs: {
                    productId: _vm.productId,
                    moduleCollapsed: _vm.moduleCollapsed("services"),
                    result: _vm.serviceResults,
                    "services-enabled": _vm.isInternal,
                  },
                  on: {
                    "next-started": function ($event) {
                      return _vm.showModule("checkout")
                    },
                    "update-summary": _vm.updateSummary,
                    "next-loaded": _vm.assignCheckoutResults,
                    "section-clicked": _vm.stepBackFrom,
                    failed: function ($event) {
                      return _vm.showModule("datepicker")
                    },
                  },
                })
              : _c("booking-section", {
                  attrs: {
                    preview: true,
                    title: _vm.$t("booking.sectionTitles.services"),
                  },
                }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.moduleVisible("leadForm") || _vm.moduleVisible("checkout")
        ? [
            _vm.moduleVisible("leadForm")
              ? _c("lead-form", {
                  ref: "leadForm",
                  attrs: {
                    productId: _vm.productId,
                    moduleCollapsed: _vm.moduleCollapsed("leadForm"),
                    result: _vm.flightDetails || _vm.serviceResults,
                  },
                  on: {
                    "next-started": function ($event) {
                      return _vm.showModule("checkout")
                    },
                    "update-summary": _vm.updateSummary,
                    "next-loaded": _vm.assignCheckoutResults,
                    "section-clicked": _vm.stepBackFrom,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.moduleVisible("checkout")
              ? _c("checkout", {
                  ref: "checkout",
                  attrs: {
                    productId: _vm.productId,
                    result: _vm.checkoutResults,
                  },
                })
              : _vm._e(),
          ]
        : _c("booking-section", {
            attrs: {
              preview: true,
              title: _vm.$t("booking.sectionTitles.checkout"),
            },
          }),
      _vm._v(" "),
      _vm.summaryEnabled
        ? _c("summary-sidebar", {
            attrs: { summary: _vm.summary, currentPrice: _vm.currentPrice },
            on: {
              "toggle-summary": function ($event) {
                _vm.summaryVisible = !_vm.summaryVisible
              },
              "section-clicked": _vm.stepBackFrom,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "reveal-overlay hide-in-sales",
          attrs: { id: "booking-error-overlay" },
        },
        [
          _c("div", { staticClass: "inner" }, [
            _c("h3", { staticClass: "text-center" }, [
              _vm._v(
                "Ihre Buchungsanfrage konnte leider nicht bearbeitet werden"
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "error-content" }),
            _vm._v(" "),
            _c("div", { staticClass: "text-center" }, [
              _c(
                "a",
                {
                  staticClass: "cta cta--secondary cta--small cta--inline",
                  on: {
                    click: function ($event) {
                      return _vm.hideErrorMessage()
                    },
                  },
                },
                [_vm._v("Meldung schließen")]
              ),
            ]),
          ]),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }